import { render, staticRenderFns } from "./Rcs.vue?vue&type=template&id=366c852b&"
import script from "./Rcs.vue?vue&type=script&lang=js&"
export * from "./Rcs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports